export function dateToTimeString(localTime: Date) {
    return localTime.toLocaleTimeString('ru-RU', { hour: '2-digit', minute: '2-digit' })
}
